<template>
        <div
          class="required-block required-block-geodesia mb-1 attachments-block-collapse-wrapper"
          v-if="a.hasPermission('edit projects')"
        >
          <b-button
            variant="link"
            @click="a.checkThemAll(8)"
          >
            <h6 class="required-block-title">
              <feather-icon
                :icon="a.show_attachments_block8 ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                size="16"
                class="mr-1"
              />
              جيوديسيا
            </h6>
          </b-button>
          <b-collapse v-model="a.show_attachments_block8">
            <team-editor-card type="geodesia" />

            <div class="d-flex flex-wrap required-block-cards">
              <attachment-media-card
                v-for="card in a.requiredCardsBlockGeodesia"
                :key="`required-geodesia-${card.key}`"
                :title="card.key"
                :file="card.file"
                :upload-value="a.requiredUploads[card.key]"
                upload-layout="inline"
                :show-team-disabled-message="a.isUploadDisabledByTeam(card.key)"
                :accept="a.getAcceptExtensions(card.key)"
                :upload-disabled="a.isUploadDisabledByTeam(card.key)"
                :uploading="a.isUploadingRequired(card.key)"
                card-margin-class="mb-1"
                notes-section-class=""
                notes-textarea-class=""
                :show-collection-checkbox="a.isProject168 && Boolean(card.file)"
                :collection-selected="Boolean(card.file && a.isCollectionSelected(card.file))"
                :editing-note="a.isFileNoteEditing(card.file)"
                :note-draft="a.getFileNoteDraft(card.file)"
                :saving-note="a.isFileNoteSaving(card.file)"
                @update:upload-value="a.setRequiredUpload(card.key, $event)"
                @submit-upload="a.submitRequired(card.key)"
                @delete="a.deleteFile(card.file.id)"
                @save-note="a.saveNote(card.file)"
                @cancel-edit-note="a.cancelEditingNote(card.file.id)"
                @start-edit-note="a.startEditingNote(card.file)"
                @update:note-draft="a.setFileNoteDraft(card.file, $event)"
                @collection-change="a.onCollectionCheckboxChange(card.file, $event)"
              />
            </div>

            <div class="d-flex flex-wrap align-items-start gap-1 w-100 mt-2 mb-2">
              <div class="import-buttons-container">
                <div class="icon-container">
                  <img
                    class="img"
                    :src="require('@/assets/images/icons/HTMLIcon.jpeg')"
                    alt="HTML"
                  />
                </div>
                <div class="buttons-container">
                  <b-button
                    v-if="a.hasPermission('view projects')"
                    variant="dark"
                    size="sm"
                    class="btnSM"
                    title="تصدير HTML من JXL"
                    :disabled="a.exportingJxlHtml"
                    @click="a.exportProjectJxlHtml"
                  >
                    <b-spinner
                      v-if="a.exportingJxlHtml"
                      small
                    />
                    <feather-icon
                      v-else
                      icon="FileTextIcon"
                      size="12"
                    />
                  </b-button>
                  <b-button
                    v-if="a.hasPermission('edit projects')"
                    variant="success"
                    size="sm"
                    class="btnSM"
                    title="رفع ملف HTML"
                    :disabled="a.isUploadingConditional('html_raw_control')"
                    @click="a.triggerGeodesiaHtmlUpload"
                  >
                    <b-spinner
                      v-if="a.isUploadingConditional('html_raw_control')"
                      small
                    />
                    <feather-icon
                      v-else
                      icon="UploadIcon"
                      size="12"
                    />
                  </b-button>
                  <b-button
                    v-if="a.geodesiaHtmlMediaFile && a.canViewMediaFile(a.geodesiaHtmlMediaFile)"
                    variant="info"
                    size="sm"
                    class="btnSM"
                    title="عرض HTML"
                    :href="a.geodesiaHtmlMediaFile.url"
                    target="_blank"
                  >
                    <feather-icon
                      icon="EyeIcon"
                      size="12"
                    />
                  </b-button>
                  <b-button
                    v-if="a.geodesiaHtmlMediaFile"
                    variant="primary"
                    size="sm"
                    class="btnSM"
                    title="تحميل HTML"
                    :href="a.geodesiaHtmlMediaFile.download_url || a.geodesiaHtmlMediaFile.url"
                    target="_blank"
                  >
                    <feather-icon
                      icon="DownloadIcon"
                      size="12"
                    />
                  </b-button>
                  <b-button
                    v-if="a.geodesiaHtmlMediaFile && a.hasPermission('delete media')"
                    variant="danger"
                    size="sm"
                    class="btnSM"
                    title="حذف HTML"
                    @click="a.deleteConditionalFile('html_raw_control', a.geodesiaHtmlMediaFile.id)"
                  >
                    <feather-icon
                      icon="Trash2Icon"
                      size="12"
                    />
                  </b-button>
                </div>
              </div>

              <div class="import-buttons-container">
                <div class="icon-container">
                  <img
                    class="img"
                    :src="require('@/assets/images/icons/TrimbleIcon.jpeg')"
                    alt="JXL"
                  />
                </div>
                <div class="buttons-container">
                  <b-button
                    v-if="a.hasPermission('generate jxlFiles')"
                    variant="secondary"
                    size="sm"
                    class="btnSM"
                    title="إنشاء JXL"
                    :disabled="a.generatingJxl || !a.firstProjectLocationId"
                    @click="a.generateProjectJxl"
                  >
                    <b-spinner
                      v-if="a.generatingJxl"
                      small
                    />
                    <feather-icon
                      v-else
                      icon="FilePlusIcon"
                      size="12"
                    />
                  </b-button>
                  <b-button
                    v-if="a.hasPermission('edit projects')"
                    variant="success"
                    size="sm"
                    class="btnSM"
                    title="استيراد ملف JXL"
                    :disabled="a.jxlImportLoading || a.isRawControlUploadDisabled"
                    @click="a.handleJxlImportClick"
                  >
                    <b-spinner
                      v-if="a.jxlImportLoading"
                      small
                    />
                    <feather-icon
                      v-else
                      icon="UploadIcon"
                      size="12"
                    />
                  </b-button>
                  <b-button
                    v-if="a.geodesiaJxlMediaFile && a.canViewMediaFile(a.geodesiaJxlMediaFile)"
                    variant="info"
                    size="sm"
                    class="btnSM"
                    title="عرض JXL"
                    :href="a.geodesiaJxlMediaFile.url"
                    target="_blank"
                  >
                    <feather-icon
                      icon="EyeIcon"
                      size="12"
                    />
                  </b-button>
                  <b-button
                    v-if="a.geodesiaJxlMediaFile"
                    variant="primary"
                    size="sm"
                    class="btnSM"
                    title="تحميل JXL"
                    :href="a.geodesiaJxlMediaFile.download_url || a.geodesiaJxlMediaFile.url"
                    target="_blank"
                  >
                    <feather-icon
                      icon="DownloadIcon"
                      size="12"
                    />
                  </b-button>
                  <b-button
                    v-if="a.geodesiaJxlMediaFile && a.hasPermission('delete media')"
                    variant="danger"
                    size="sm"
                    class="btnSM"
                    title="حذف JXL"
                    @click="a.deleteFile(a.geodesiaJxlMediaFile.id)"
                  >
                    <feather-icon
                      icon="Trash2Icon"
                      size="12"
                    />
                  </b-button>
                </div>
              </div>
            </div>

            <ProjectNoteEditor
              :project-id="a.projectId"
              group="attachments_geodesia"
              label="ملاحظات جيوديسيا"
              class="mb-2"
            />

            <geodesia-acknowledgment-section
              v-if="a.projectId"
              :project-id="a.projectId"
            />
          </b-collapse>
          <b-button
            class="attachments-block-collapse-toggle-btn"
            variant="light"
            size="sm"
            @click="a.show_attachments_block8 = !a.show_attachments_block8"
            v-b-tooltip.hover.top="a.show_attachments_block8 ? 'إخفاء' : 'إظهار'"
          >
            <feather-icon
              :icon="a.show_attachments_block8 ? 'ChevronUpIcon' : 'ChevronDownIcon'"
              size="16"
              class="mr-25"
            />
          </b-button>
        </div>
</template>

<script>
import attachmentsBlockMixin from '../attachmentsBlockMixin'
import GeodesiaAcknowledgmentSection from '../../geodesia/GeodesiaAcknowledgmentSection.vue'

export default {
  name: 'AttachmentsBlockGeodesia',
  mixins: [attachmentsBlockMixin],
  components: {
    GeodesiaAcknowledgmentSection,
  },
}
</script>

<style src="../attachments-shared.scss" lang="scss"></style>
